







































import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "BaseTooltip",
  components: { BaseIconButton },
  props: {
    title: { type: String as PropType<TranslateResult | string> },
    text: { type: [String, Array] as PropType<TranslateResult | TranslateResult[]>, default: "" },
    autoShowHint: { type: Boolean, default: false },
    hideIcon: { type: Boolean, default: false },
    hideCloseIcon: { type: Boolean, default: false },
    enableOverlayClick: { type: Boolean, default: true },
  },
  data() {
    return {
      showHint: this.autoShowHint,
    };
  },
  methods: {
    toggleShowHint() {
      this.showHint = !this.showHint;
    },
    onCloseButtonClick() {
      this.$emit("close");
      this.toggleShowHint();
    },
    onEnter(el: HTMLElement, done: Function) {
      const { right, left } = el.getBoundingClientRect();
      const offset = 12;
      let newValue = "";
      if (left < offset) newValue = `0% - 6px`;
      if (right > window.innerWidth - offset) newValue = `100% + 6px`;
      if (newValue) el.style.setProperty("--left-position", newValue);
      done();
    },
    onAfterLeave(el: HTMLElement) {
      el.style.setProperty("--left-position", "100% + 6px");
    },
  },
});
